var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('p',[_c('span',[_vm._v("COPYRIGHT @ "+_vm._s(new Date().getFullYear())+" FAMS v2.0 | Powered by "),_c('a',{attrs:{"href":"fams.co.za","target":"_blank","rel":"nofollow"}},[_vm._v("fams.co.za")]),_vm._v(". All rights Reserved")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }